<template>
    <div>
        <b-modal ref="show-notification-record"
                 size="xl"
                 :title="$t('notification_record.title')"
                 hide-footer>
            <b-row>
                <b-col>
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="notificationRecords.length"
                            :per-page="perPage"
                    ></b-pagination>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-table hover
                             responsive
                             sticky-header
                             :fields="fields"
                             :items="notificationRecords"
                             :current-page="currentPage"
                             :per-page="perPage">
                        <template v-slot:cell(email)="data">
                            <b-button v-b-toggle="data.item.id" v-if="data.value" class="mb-2">{{$t('notification_record.toggle_email_details')}}</b-button>

                            <b-collapse :id="data.item.id" v-if="data.value">
                                <b-form-group :label="$t('notification_record.email_subject')">
                                    <b-form-input :value="data.value.subject" readonly></b-form-input>
                                </b-form-group>
                                <b-form-group :label="$t('notification_record.email_content')">
                                    <b-card v-html="data.value.content"></b-card>
                                </b-form-group>
                            </b-collapse>
                        </template>
                        <template v-slot:cell(notification)="data">
                            <b-form-input :value="data.value.content" readonly v-if="data.value"></b-form-input>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

        </b-modal>
    </div>
</template>

<script>
    import {DateTime} from 'luxon'

    export default {
        name: 'NotificationRecordModal',
        data() {
            return {
                notificationRecords: [],
                fields: [
                    {
                        key: 'create_at', label: this.$t('notification_record.create_at'),
                        sortable: true, sortByFormatted: true,
                        formatter(value, key, item) {
                            return DateTime.fromISO(item.create_at).toFormat('yyyy-MM-dd HH:mm');
                        },
                    },
                    {
                        key: 'template', label: this.$t('notification_record.template'),
                        sortable: true, sortByFormatted: true,
                        formatter(value, key, item) {
                            return item.template.name
                        },
                    },
                    {
                        key: 'type', label: this.$t('notification_record.type'),
                        sortable: true,
                    },
                    {
                        key: 'email', label: this.$t('notification_record.email'),
                        sortable: true, sortByFormatted: true,
                        formatter(value, key, item) {
                            return item.emails.slice(-1)[0];
                        },
                    },
                    {
                        key: 'notification', label: this.$t('notification_record.push_notification'),
                        sortable: true, sortByFormatted: true,
                        formatter(value, key, item) {
                            return item.push_notifications.slice(-1)[0];
                        },
                    },
                ],
                currentPage: 0,
                perPage: 20,
            }
        },
        mounted() {
            var v = this;
            this.$eventHub.$on('showNotificationRecord', function (records) {
                v.notificationRecords = records;
                v.currentPage = 0;
                v.$refs['show-notification-record'].show();
            })
        },
        beforeDestroy() {
            this.$eventHub.$off('showNotificationRecord');
        }
    }
</script>